import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'mage-components';
import { Frame, SelectorActionsheet, Typography } from '@klarna/bubble-ui';
import { text } from './constants';
const componentPropTypes = {
    currentConfig: PropTypes.object.isRequired,
};
export const Configuration = ({ currentConfig }) => (React.createElement(Frame, null,
    React.createElement(Row, null,
        React.createElement(Column, { columns: { mobile: 12 } },
            React.createElement(Typography, { textToken: "text-style/headings/titles/bold/tertiary" }, "Configuration"))),
    React.createElement(SelectorActionsheet, { options: Object.entries(currentConfig)
            .filter(([, v]) => typeof v === 'string' || v instanceof String)
            .map(([k, v]) => {
            var _a, _b;
            return ({
                value: k,
                label: (_a = text[k]) === null || _a === void 0 ? void 0 : _a.title(v),
                description: (_b = text[k]) === null || _b === void 0 ? void 0 : _b.description(v),
            });
        }) })));
Configuration.propTypes = componentPropTypes;
